module.exports = __webpack_public_path__ + "files/db71b6e7163747c6d32cc91fb8e2be70.png";